import { Navigate, Route, Routes } from 'react-router-dom';
import { PageTitle } from '../../../_start/layout/core';
import GoogleReviewsPage from '../../modules/google-reviews/GoogleReviewsPage';

export const GoogleMyBusinessPage = () => {
  return (
    <Routes>
      {/* begin::Group */}
      <Route
        index
        element={
          <>
            <PageTitle>Google Reviews</PageTitle>
            <GoogleReviewsPage />
          </>
        }
      />

      <Route path="*" element={<Navigate to="/google-reviews" replace />} />
    </Routes>
  );
};
